module.exports = __webpack_public_path__ + "static/media/b7@2x.52a5c140.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/floorplans/floorplates/b7@2x.png
// module id = 231
// module chunks = 0